// ============================================================
// Group Buy Flats — Builder → Logo image mapping
// ============================================================
//
// This file is the SINGLE SOURCE OF TRUTH for which builders are
// "featured": they appear in the home-page "Our Builder Network"
// carousel, in the Developers-page 3-row carousel, AND get their
// own dedicated page at /builder/<slug>.
//
// ── HOW TO ADD A NEW BUILDER ────────────────────────────────
//   1. Drop the logo file into  src/assets/logos/
//        e.g.  src/assets/logos/New Builder.png
//   2. Import it at the top of this file:
//        import newBuilder from "../assets/logos/New Builder.png";
//   3. Add ONE line to BUILDER_TO_LOGO below, using the builder's
//      SLUG as the key (see "HOW THE SLUG IS MADE" right below):
//        "new-builder": newBuilder,
//      (If you don't have a logo yet, use `null` — the carousel
//       shows a clean gold-initial tile, and the page still works.)
//   4. Make sure the builder has at least one project in Supabase
//      whose `builder_name` slugifies to the SAME slug. The
//      dedicated page is built automatically from those projects.
//
//   That's it — the logo shows up and /builder/new-builder works.
//   No routing or component changes are ever needed.
//
// ── HOW THE SLUG IS MADE ────────────────────────────────────
//   slug = builder_name → lowercase → every run of non-letter/
//   number characters becomes a single "-" → trim leading/trailing
//   "-".  Examples:
//     "Vertex Homes"            → "vertex-homes"
//     "GPR Farms & Ventures"    → "gpr-farms-ventures"
//     "Beams & Columns LLP"     → "beams-columns-llp"
//   Use the builderSlug() helper below if you're unsure.
// ============================================================

// Import logos
import ameyaSpaces from "../assets/logos/Aspire Spaces.webp";
import beamsColumns from "../assets/logos/beamcolumns_logo.png";
import bhanodayaConstructions from "../assets/logos/Bhanodaya Constructions.webp";
import bharathiConstructions from "../assets/logos/Bharathi Constructions.png";
import blissVentures from "../assets/logos/Bliss Ventures Pvt.avif";
import casagrand from "../assets/logos/Casagrand Logo.png";
import cozyEssenceBuilders from "../assets/logos/Cozy Essence Builders.webp";
import dnbConstructions from "../assets/logos/Dnb Constructions.svg";
import gprFarmsVentures from "../assets/logos/GPR Farms and Ventures Pvt Ltd.png";
import hivisionDevelopers from "../assets/logos/Hivision Developers.png";
import janapriyaEngineersSyndicate from "../assets/logos/Janapriya Engineers Syndicate.jpg";
import lansumGroup from "../assets/logos/Lansum Group.svg";
import mahaveerGroup from "../assets/logos/Mahaveer Group.png";
import nikhilaConstructions from "../assets/logos/Nikhila Constructions.png";
import oorjitaProjects from "../assets/logos/Oorjita Projects.png";
import pacificaGroup from "../assets/logos/Pacifica Group.webp";
import ss from "../assets/logos/ssbuilders.png";
import profoundGroup from "../assets/logos/Profound Group.png";
import prosperitiHomes from "../assets/logos/Prosperiti Homes.png";
import relianceBuilders from "../assets/logos/Reliance Builders.webp";
import sriDevelopers from "../assets/logos/Sri Developers.svg";
import sriKarthikeyaBuggas from "../assets/logos/Sri Karthikeya Buggas.png";
import supadhaInfra from "../assets/logos/Supadha Infra Pvt Ltd.jpg";
import svadhaGroup from "../assets/logos/Svadha Group.webp";
import Ananta from "../assets/logos/Ananta.png";
import Vian from "../assets/logos/vian.jpeg"
import team4LifeSpaces from "../assets/logos/team4lifespaces.png";
import vertexHomes from "../assets/logos/Vertex Homes.png";
import visionArsha from "../assets/logos/Vision Arsha.png";

// Derive a builder slug from builder_name.
// MUST match BuilderPage and LogoCarousel.
export function builderSlug(builderName) {
  return (builderName || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

// Builder slug → logo mapping
export const BUILDER_TO_LOGO = {
  // === NEW BUILDERS ONLY ===
  "ameya-spaces": ameyaSpaces,
  "ananta-realtors-consultants": Ananta,
  "beams-columns-llp": beamsColumns,
  "bhanodaya-constructions": bhanodayaConstructions,
  "bharathi-constructions": bharathiConstructions,
  "bliss-ventures-pvt": blissVentures,
  "casagrand": casagrand,
  "cozy-essence-builders": cozyEssenceBuilders,
  "dnb-constructions": dnbConstructions,
  "gpr-farms-and-ventures-pvt-ltd": gprFarmsVentures,
  "hivision-developers": hivisionDevelopers,
  "janapriya-engineers-syndicate": janapriyaEngineersSyndicate,
  "lansum-group": lansumGroup,
  "mahaveer-group": mahaveerGroup,
  "nikhila-constructions": nikhilaConstructions,
  "oorjita-projects": oorjitaProjects,
  "ss-builders": ss,
  "pacifica-group": pacificaGroup,
  "profound-group": profoundGroup,
  "prosperiti-homes": prosperitiHomes,
  "reliance-builders": relianceBuilders,
  "sri-developers": sriDevelopers,
  "sri-karthikeya-buggas": sriKarthikeyaBuggas,
  "supadha-infra-pvt-ltd": supadhaInfra,
  "svadha-group": svadhaGroup,
  "team-4-life-spaces": team4LifeSpaces,
  "vertex-homes": vertexHomes,
  "vian" : Vian,
  "vision-arsha": visionArsha,
};

export default BUILDER_TO_LOGO;